import React from 'react';
import { User } from '../types';
import UserTableRow from './UserTableRow';
import InfiniteScroll from 'react-infinite-scroll-component';

interface Props {
  data: User[];
  onDelete: (idx: string) => void;
  loadMore: () => void;
  hasMore: boolean;
  // If needed, uncomment and pass to row:
  // anchorEl?: HTMLElement | null;
  // rowIdx?: string | null;
}

const headers = [
  { label: 'User Name', width: '150px' },
  { label: 'Join Date', width: '96px' },
  { label: 'Email', width: '250px' },
  { label: 'Phone', width: '160px' },
  { label: 'Activity', width: '96px' },
  { label: 'Gender', width: '96px' },
  { label: 'Action', width: '80px' },
];

const UsersTable: React.FC<Props> = ({ data, onDelete, loadMore, hasMore }) => (
  <div className="relative h-full">
    {/* give InfiniteScroll a real target */}
    <div id="gamic-scroll" className="absolute inset-0 overflow-auto">
      <InfiniteScroll
        dataLength={data.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<div className="p-4 text-center text-sm">Loading…</div>}
        endMessage={<div className="p-4 text-center text-xs text-gray-500">No more users</div>}
        scrollableTarget="gamic-scroll"
        className="!overflow-visible"
      >
        <table className="w-full min-w-max table-fixed text-left">
          <colgroup>
            {headers.map((h, i) => (
              <col key={i} style={{ width: h.width }} />
            ))}
          </colgroup>

          <thead className="sticky top-0 bg-white z-10 border-b">
            <tr>
              {headers.map((h, i) => (
                <th
                  key={h.label}
                  className={`px-4 py-[18px] font-bold whitespace-nowrap ${
                    i === headers.length - 1 ? 'pr-[21px]' : ''
                  }`}
                >
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((user) => (
              <UserTableRow
                key={user.id}
                user={user}
                idx={user.id}
                onDelete={onDelete}
              />
            ))}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  </div>
);

export default UsersTable;
